import { z } from 'zod'

export const whatsNewFormSchema = z.object({
  version_title: z.string().min(1, 'Title is required'),
  version_description: z.string().min(1, 'Description is required'),
  version_date: z
    .string()
    .min(1, 'Date is required')
    .regex(/^\d{4}-\d{2}-\d{2}$/, 'Date must be in YYYY-MM-DD format'),
  version_type: z.enum(['PROCESS_CHANGE', 'PROCESS_IMPROVEMENT', 'NEW_FEATURE'], {
    message: 'Version type is required',
  }),
})

export type WhatsNewFormValues = z.infer<typeof whatsNewFormSchema>
